export default {
  name: 'index',
  data: function data() {
    return {
      fullscreenLoading: false,
      tableData: [{
        type: '纸质银行函证',
        num: 4,
        desc: '涉及中国境内(不含港澳台）银行询证函的发送，业务人员需在银行函证发函统计表（腾讯在线共享文档）登记相关发函信息，后续可在发函信息汇总表查看函证收发情况。',
        links: [{
          name: '发函信息收集网页链接',
          url: 'https://docs.qq.com/form/page/DQWxwZFlMSnFGQlZ3?needShowTips=1#/fill-detail',
          type: 'primary'
        }, {
          name: '发函信息汇总表网页链接',
          url: 'https://docs.qq.com/sheet/DQWlJZFhXbU9MZXV3?tab=doz8mi&_t=1735307254392&nlc=1&nlc=1&viewId=fv1',
          type: 'success'
        }]
      }, {
        desc: '涉及银行函证退函，函证中心将建立腾讯在线共享文档表格登记，业务人员如需查看退函情况统计表，可登录以下网页链接进行查阅。',
        links: [{
          name: '银行退函汇总统计表网页链接',
          url: 'https://docs.qq.com/sheet/DQWlJZFhXbU9MZXV3?tab=whnml7&_t=1735307254392&nlc=1&nlc=1',
          type: 'primary'
        }]
      }, {
        desc: '银行函证涉及二次发函，业务人员需在银行函证统计表（腾讯在线共享文档）登记相关发函信息，对应发函函证需在“CPSC审计插件模板【银行询证函模板】”设为“草稿”状态，并同步更新函证系统数据服务器，再设为“已审核”状态，并同步更新函证系统服务器数据，才能重新发函。',
        links: [{
          name: '二次发函登记网页链接',
          url: 'https://docs.qq.com/form/page/DQWxwZFlMSnFGQlZ3?u=08f0e8fa046d4205b10b5896ab0399b1#/fill-detail',
          type: 'primary'
        }, {
          name: '二次发函发函信息汇总表网页链接',
          url: 'https://docs.qq.com/sheet/DQWlJZFhXbU9MZXV3?tab=ljd1ii',
          type: 'success'
        }]
      }, {
        desc: '涉及待发银行函证手续不全，未达到可发状态，函证中心已建立腾讯在线共享文档表格登记，业务人员如需查看情况统计表，可登录以下网页链接进行查阅。',
        links: [{
          name: '待发银行函证手续不全，未达到可发状态汇总表网页链接',
          url: 'https://docs.qq.com/sheet/DQWlJZFhXbU9MZXV3?tab=ahwyfp&_t=1735307254392&nlc=1&nlc=1',
          type: 'primary'
        }]
      }, {
        type: '纸质非银行函证',
        num: 2,
        desc: '需由函证中心集中发往中国境内（不含港澳台）纸质非银行函证',
        links: [{
          name: '发函信息收集网页链接',
          url: 'https://docs.qq.com/form/page/DQWxwZFlMSnFGQlZ3?u=08f0e8fa046d4205b10b5896ab0399b1#/fill-detail',
          type: 'primary'
        }, {
          name: '发函信息汇总表网页链接',
          url: 'https://docs.qq.com/sheet/DQWlJZFhXbU9MZXV3?tab=ljd1ii',
          type: 'success'
        }]
      }, {
        desc: '涉及待发非银行函证手续不全，未达到可发状态，函证中心已建立腾讯在线共享文档表格登记，业务人员如需查看情况统计表，可登录以下网页链接进行查阅。',
        links: [{
          name: '待发非银行函证手续不全，未达到可发状态汇总表网页链接。',
          url: 'https://docs.qq.com/sheet/DQWlJZFhXbU9MZXV3?tab=7gk2z5&_t=1735307254392&nlc=1&nlc=1',
          type: 'primary'
        }]
      }]
    };
  },
  methods: {
    objectSpanMethod: function objectSpanMethod(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      if (columnIndex === 0) {
        if (row.type && row.num) {
          return {
            rowspan: row.num,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  }
};